import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { useProductCategories } from "@/common/hooks/queries/useProductCategories";
import { Mapper } from "@/common/services/mapper";
import { ProductCategoryTransformer } from "@/features/productCategories/services/productCategoryTransformer";
import { ProductCategoryData, ProductCategoryTableItem } from "@/features/productCategories/types/productCategories";
import { Boxes, Search } from "lucide-react";
import { defaultColumns } from "../../constants/columns.constant";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import useDebounce from "@/common/hooks/useDebounce";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const ProductCategories = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: productCategories,
    meta,
    isPending: isPendingProductCategories,
    isLoading: isLoadingProductCategories,
    error: productCategoriesError = {} as any,
    refetch: refetchProductCategories,
  } = useProductCategories({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<ProductCategoryData[], ProductCategoryTableItem[]>({
      transformer: ProductCategoryTransformer.tableTransformer('Admin::ProductCategories::Show')
    })
  });

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<Boxes className="w-10 h-10" strokeWidth={1.5} />}
          title="Categorias de Produtos"
          createButtonText="Nova categoria"
          dataTestid="create_product_categories_button"
          operationKlassToCheckPermission="Admin::ProductCategories::Create"
          disableCreateButton={isPendingProductCategories || productCategoriesError?.status === 403}
        />

        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={productCategoriesError?.status}
          refetchFunction={refetchProductCategories}
        >
          <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
            <TextField
              LeftIcon={<Search />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
              }}
              value={filterParams.search}
            />

            <Table
              columns={defaultColumns}
              isLoadingData={isLoadingProductCategories}
              page={filterParams.page || 1}
              rows={productCategories}
              totalPages={meta.total_pages}
              totalCount={meta.total}
              hasPagination
              setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            />
          </div>
        </ErrorMessageWrapper>
      </div>
    </div>
  );
};

export default ProductCategories;
